// src/component/ProtectedRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ element: Element, ...rest }) => {
  let authToken = localStorage.getItem('token') || sessionStorage.getItem('token');
  return authToken ? <Element {...rest} /> : <Navigate to="/login" />;
};

export default ProtectedRoute;